module.exports = __webpack_public_path__ + "img/form2.bff12940.png";